export enum RegisteredDeviceSituationEnum {
  BLOCKED = 'BLOQUEADO',
  ACTIVE = 'ATIVO',
  PENDING_APPROVAL = 'PENDENTE_APROVACAO',
}

export type RegisteredDeviceType = {
  IdentDispositivo: string;
  Data: string;
  Modelo: string;
  Situacao: RegisteredDeviceSituationEnum;
};



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/device-management/models/registered-device.ts